<template>
  <div class="analysis" >
    <el-row class="mb20">
      <el-col :span="24">
        <el-card>
          <el-row>
            <el-col :span="10">
              <el-select v-model="orderPark" placeholder="选择园区" size="mini" clearable @change="handelParkChange">
                <el-option :value="1" label="上海园区"></el-option>
                <el-option :value="2" label="南京园区"></el-option>
                <el-option :value="3" label="徐州园区"></el-option>
                <el-option :value="6" label="北京园区"></el-option>
                <el-option :value="7" label="天津园区"></el-option>
                <el-option :value="8" label="江苏园区"></el-option>
                <el-option :value="9" label="浙江园区"></el-option>
                <el-option :value="10" label="广东园区"></el-option>
                <el-option :value="11" label="江西园区"></el-option>
                <el-option :value="12" label="山东园区"></el-option>
                <el-option :value="13" label="山西园区"></el-option>
                <el-option :value="14" label="河南园区"></el-option>
                <el-option :value="15" label="河北园区"></el-option>
                <el-option :value="16" label="湖南园区"></el-option>
                <el-option :value="17" label="湖北园区"></el-option>
                <el-option :value="18" label="贵州园区"></el-option>
                <el-option :value="19" label="陕西园区"></el-option>
                <el-option :value="20" label="四川园区"></el-option>
                <el-option :value="21" label="安徽园区"></el-option>
              </el-select>
            </el-col>
          </el-row>
        </el-card>
      </el-col>
    </el-row>
    <el-row class="mb20">
      <el-col :span="24">
        <el-card>
          <el-row class='text-r'>
            <el-col :span="24">
              <el-date-picker
                style="margin-left: .2rem"
                size='mini'
                v-model="orderDate"
                type="daterange"
                align="right"
                unlink-panels
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                value-format="yyyy-MM-dd"
                :picker-options="pickerOptions"
                @change="orderFilter">
              </el-date-picker>
            </el-col>
          </el-row>
          <div class="charBox" ref="orderbox"></div>
        </el-card>
      </el-col>
    </el-row>
    <el-row class="mb20" :gutter="20">
      <el-col :span="12">
        <el-card>
          <div class="charBox" ref="statusbox"></div>
        </el-card>
      </el-col>
      <el-col :span="12">
        <el-card>
          <div class="charBox" ref="regTypebox"></div>
        </el-card>
      </el-col>
    </el-row>
    <el-row class="mb20">
      <el-col :span="24">
        <el-card>
          <div class="charBox" ref="chartbox"></div>
        </el-card>
      </el-col>
    </el-row>
    <el-row class="mb20" :gutter="20">
      <el-col :span="8">
        <el-card class="cardBox" :class="{'activeBg': activeCard === 1}" @click.native="setActiveCard(1)">
          <div :class="activeCard === 1 ? 'activeCardColor' : 'cardColor'">
            <h4 class="cardBoxName">退款订单分析</h4>
            <h4 class="cardBoxName">{{refundTotal}}</h4>
          </div>
        </el-card>
      </el-col>
      <el-col :span="8">
        <el-card class="cardBox" :class="{'activeBg2': activeCard === 2}" @click.native="setActiveCard(2)">
          <div :class="activeCard === 2 ? 'activeCardColor' : 'cardColor'">
            <h4 class="cardBoxName">实际注册类型(不含退款)</h4>
            <h4 class="cardBoxName">{{regTypeTotal}}</h4>
          </div>
        </el-card>
      </el-col>
      <el-col :span="8">
        <el-card class="cardBox" :class="{'activeBg3': activeCard === 3}" @click.native="setActiveCard(3)">
          <div :class="activeCard === 3 ? 'activeCardColor' : 'cardColor'">
            <h4 class="cardBoxName">未下代账分析(不含退款)</h4>
            <h4 class="cardBoxName">{{notProxyTotal}}</h4>
          </div>
        </el-card>
      </el-col>
    </el-row>
    <el-row class="mb20" :gutter="20">
      <el-col :span="24">
        <el-card><div class="charBox" ref="integrationChar"></div></el-card>
      </el-col>
    </el-row>
    <el-row class="mb20" :gutter="20">
      <el-col :span="24">
        <el-card>
          <div class="charBox"  ref="OrderSourceChar"></div>
        </el-card>
      </el-col>
    </el-row>
  </div>
</template>

<script>
// var echarts = require('echarts');
var echarts = require('echarts/lib/echarts')
require('echarts/lib/component/tooltip')
require('echarts/lib/component/title')
require('echarts/lib/component/legend')
require('echarts/lib/component/toolbox')
require('echarts/lib/chart/themeRiver')
require('echarts/lib/chart/bar')
require('echarts/lib/chart/line')
require('echarts/lib/chart/pie')
// require('echarts/lib/component/visualMap')
export default {
  name: 'TycAnalysis',
  data () {
    return {

      activeCard: 1,
      orderPark: '',
      orderChart: null,
      chart: null,
      orderStatusChart: null,
      proxyChart: null,
      integrationChar: null,
      OrderSourceChar: null,
      industryCount: [],
      orderDay: [],
      orderDayCount: [],
      orderTotal: 0,
      orderStatusCount: [],
      orderStatusTotal: 0,
      proxyHeader: [],
      proxyCount: [],
      proxyTotal: 0,
      refundHeader: [],
      refundCount: [],
      refundTotal: 0,
      regTypeHeader: [],
      regTypeCount: [],
      regTypeTotal: 0,
      notProxyHeader: [],
      notProxyCount: [],
      notProxyTotal: 0,
      OrderSourceCount: [],
      OrderSourceHeader: [],
      integrationHeader: [],
      integrationCount: [],
      integrationTitle: '退款订单分析',
      integrationColor: ['#5787FF'],
      orderDate: '',
      curDate: '',
      pickerOptions: {
        shortcuts: [
          {
            text: '最近7天',
            onClick (picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
              picker.$emit('pick', [start, end])
            }
          },
          {
            text: '最近15天',
            onClick (picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 15)
              picker.$emit('pick', [start, end])
            }
          }
        ],
        onPick: ({maxDate, minDate}) => {
          this.curDate = minDate.getTime()
          if (maxDate) {
            this.curDate = ''
          }
        },
        disabledDate: (time) => {
          if (this.curDate) {
            const one = 30 * 24 * 3600 * 1000
            const minTime = this.curDate - one
            const maxTime = this.curDate + one
            return time.getTime() < minTime || time.getTime() > maxTime
          }
        }
      }
    }
  },
  computed: {
    collapse () {
      return this.$store.state.collapse
    }
  },
  watch: {
    industryCount (val) {
      this.initCharts()
    },
    integrationCount (val) {
      this.initIntegrationChar()
    },
    orderDayCount (val) {
      this.initOrderChar()
    },
    OrderSourceCount (val) {
      this.initOrderSourceChar()
    }
  },
  methods: {
    getAnalysisData () {
      this.$axios.post('/api/admin/tyc_orders/analysis', {park: this.orderPark})
        .then((res) => {
          const { data } = res
          if (data.code === 0) {
            this.industryCount = data.data.industryCount
            this.orderDay = data.data.ordersCount.day
            this.orderDayCount = data.data.ordersCount.value
            this.orderTotal = data.data.ordersCount.total
            this.orderStatusCount = data.data.statusCount.statusCount
            this.orderStatusTotal = data.data.statusCount.total
            this.proxyHeader = data.data.proxyCount.header
            this.proxyCount = data.data.proxyCount.value
            this.proxyTotal = data.data.proxyCount.total
            this.regTypeHeader = data.data.regTypeCount.header
            this.regTypeCount = data.data.regTypeCount.value
            this.regTypeTotal = data.data.regTypeCount.total
            this.refundHeader = data.data.refundCount.header
            this.refundCount = data.data.refundCount.value
            this.refundTotal = data.data.refundCount.total
            this.notProxyHeader = data.data.notProxyCount.header
            this.notProxyCount = data.data.notProxyCount.value
            this.notProxyTotal = data.data.notProxyCount.total
            this.OrderSourceCount = data.data.sourceCount.data
            this.OrderSourceHeader = data.data.sourceCount.header
            this.setActiveCard(1)
            this.orderDate = ''
          }
        })
    },
    handelParkChange () {
      this.getAnalysisData()
    },
    initCharts () {
      this.chart = echarts.init(this.$refs.chartbox, 'light')
      this.setOption1()
      this.orderStatusChart = echarts.init(this.$refs.statusbox, 'light')
      this.setStatusbox()
      this.proxyChart = echarts.init(this.$refs.regTypebox, 'light')
      this.setProxyType()
    },
    initIntegrationChar () {
      this.integrationChar = echarts.init(this.$refs.integrationChar, 'light')
      this.setIntegration()
    },
    initOrderChar () {
      this.orderChart = echarts.init(this.$refs.orderbox, 'light')
      this.setOrderOption()
    },
    initOrderSourceChar () {
      this.OrderSourceChar = echarts.init(this.$refs.OrderSourceChar, 'light')
      this.setOrderSourceOption()
    },
    setActiveCard (val) {
      let title = ''
      let color = ''
      let header = []
      let count = []

      if (val === 1) {
        title = '退款订单分析'
        color = ['#5787FF']
        header = this.refundHeader
        count = this.refundCount
      } else if (val === 2) {
        title = '实际注册类型（不含退款）'
        color = ['#FFC68E']
        header = this.regTypeHeader
        count = this.regTypeCount
      } else {
        title = '未下代账分析（不含退款）'
        color = ['#AEA1FB']
        header = this.notProxyHeader
        count = this.notProxyCount
      }

      this.activeCard = val
      this.integrationTitle = title
      this.integrationColor = color
      this.integrationHeader = header
      this.integrationCount = count
    },
    setOrderOption () {
      this.orderChart.setOption({
        title: {
          text: '订单量（' + this.orderTotal + '）'
        },
        xAxis: {
          boundaryGap: false,
          type: 'category',
          data: this.orderDay
        },
        yAxis: {
          type: 'value',
          splitLine: {
            show: false
          }
        },
        series: [
          {
            data: this.orderDayCount,
            type: 'line',
            areaStyle: {},
            smooth: true,
            itemStyle: {
              normal: {
                areaStyle: {
                  type: 'default',
                  color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                    {
                      offset: 0,
                      color: '#5787FF'
                    },
                    {
                      offset: 0.5,
                      color: '#98B7FF'
                    },
                    {
                      offset: 1,
                      color: '#DEEBFF'
                    }
                  ])
                },
                lineStyle: {
                  color: '#5B88EE'
                }
              }
            }
          }
        ],
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'cross',
            label: {
              backgroundColor: '#6a7985'
            }
          }
        }
      })
    },
    setOption1 () {
      let option = {
        title: {
          text: '行业特点'
        },
        legend: {},
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          }
        },
        dataset: {
          dimensions: ['product', '含退款', '服务中及已完成'],
          source: this.industryCount
        },
        xAxis: {type: 'category'},
        yAxis: {
          splitLine: {
            lineStyle: {
              type: 'dashed'
            }
          }
        },
        series: [
          {type: 'bar'},
          {type: 'bar'}
        ],
        color: ['#5787FF', '#C8E0FF']
      }
      this.chart.setOption(option)
    },
    setStatusbox () {
      let option = {
        title: {
          text: '订单状态（' + this.orderStatusTotal + '）'
        },
        tooltip: {
          trigger: 'item',
          formatter: '{a} <br/>{b}: {c} ({d}%)'
        },
        legend: {
          orient: 'vertical',
          right: 'right',
          data: ['未分配', '服务中', '已完成', '失联', '已退款', '系统结单']
        },
        series: [
          {
            name: '订单状态',
            type: 'pie',
            radius: ['50%', '70%'],
            emphasis: {
              label: {
                show: true,
                fontSize: '30',
                fontWeight: 'bold'
              },
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: 'rgba(0, 0, 0, 0.5)'
              }
            },
            data: this.orderStatusCount,
            color: ['#C8E0FF', '#5787FF', '#FFD8B4', '#AEA1FB', '#E37C7C']
          }
        ]
      }
      this.orderStatusChart.setOption(option)
    },
    setProxyType () {
      let option = {
        title: {
          text: '代理记账需求（有效客户）（' + this.proxyTotal + '）'
        },
        tooltip: {
          trigger: 'item',
          formatter: '{a} <br/>{b} : {c} ({d}%)'
        },
        legend: {
          orient: 'vertical',
          right: 'right',
          data: this.proxyHeader
        },
        series: [
          {
            name: '代理记账需求',
            type: 'pie',
            radius: '55%',
            center: ['50%', '60%'],
            data: this.proxyCount,
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: 'rgba(0, 0, 0, 0.5)'
              }
            }
          }
        ],
        color: ['#5787FF', '#C8E0FF', '#FFD8B4', '#AEA1FB']
      }
      this.proxyChart.setOption(option)
    },
    setIntegration () {
      let option = {
        toolbox: {
          show: true,
          feature: {
            saveAsImage: {
              type: 'png',
              show: true
            }
          }
        },
        title: {
          text: this.integrationTitle
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          }
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true
        },
        xAxis: {
          type: 'value',
          splitLine: {
            lineStyle: {
              type: 'dashed'
            }
          }
        },
        yAxis: {
          type: 'category',
          data: this.integrationHeader
        },
        series: [
          {
            data: this.integrationCount,
            type: 'bar',
            itemStyle: {
              normal: {
                label: {
                  show: true,
                  position: 'right',
                  textStyle: {
                    color: 'black',
                    fontSize: 16
                  }
                }
              }
            }
          }
        ],
        color: this.integrationColor
      }
      this.integrationChar.setOption(option)
    },
    setOrderSourceOption () {
      let option = {
        title: {
          text: '订单来源'
        },
        color: ['#5787FF'],
        tooltip: {
          trigger: 'axis',
          axisPointer: { // 坐标轴指示器，坐标轴触发有效
            type: 'shadow' // 默认为直线，可选为：'line' | 'shadow'
          }
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true
        },
        xAxis: [
          {
            type: 'category',
            data: this.OrderSourceHeader,
            axisTick: {
              alignWithLabel: true
            }
          }
        ],
        yAxis: [
          {
            type: 'value'
          }
        ],
        series: [
          {
            name: '',
            type: 'bar',
            barWidth: '60%',
            data: this.OrderSourceCount
          }
        ]
      }
      this.OrderSourceChar.setOption(option)
    },
    orderFilter (val) {
      this.$axios.post('/api/admin/tyc_analysis/order_filter', {val: val, park: this.orderPark})
        .then((res) => {
          const { data } = res
          if (data.code === 0) {
            this.orderDayCount = data.data.ordersCount.value
            this.orderDay = data.data.ordersCount.day
            this.orderTotal = data.data.ordersCount.total
          } else {
            this.$message.error(data.msg)
          }
        })
    }
  },
  mounted () {
    this.getAnalysisData()
  }
}
</script>

<style lang="stylus" scoped>
  @import '~styles/varibles.styl'
  @import '~styles/vertical.styl'
  .clearfix:before,
  .clearfix:after
    display: table
    content: ""
  .text-r
    text-align: right
  .analysis
    marginLeft()
    .mb20
      margin-bottom: .4rem
    .charBox
      width: 100%
      height: 6rem
    .cardBox
      height: 2rem
      cursor: pointer
    .cardBoxDiv
      height: 100%
    .cardBoxName
      font-size: .4rem
      font-weight: 400
      line-height: .6rem
    .activeBg
      background-color: #5787FF !important
    .activeBg2
      background-color: #FFC68E !important
    .activeBg3
      background-color: #AEA1FB !important
    .cardColor
      color: #A2A2A2
    .activeCardColor
      color: #FFFFFF
</style>



// WEBPACK FOOTER //
// src/pages/tyc_analysis/TycAnalysis.vue